<template>
  <div>
    <report-template-list-dialog
      :templates="getReportTemplateList"
      :loading="loading"
      @edit="handleEdit"
      @delete="handleDelete"
    />
    <report-template-name-dialog />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ReportTemplateListDialog from 'organisms/reports/ReportTemplateListDialog';
import ReportTemplateNameDialog from 'organisms/reports/ReportTemplateNameDialog';

import { EVENT_BUS } from '@/eventBus';
// import HTTPService from '@/services/Http';
// import logrocket from '@/services/logrocket';

export default {
  name: 'ReportsController',
  components: {
    ReportTemplateListDialog,
    ReportTemplateNameDialog,
  },
  async created() {
    EVENT_BUS.$on('EVENT_GET_REPORT_LIST', this.loadData);
  },

  beforeDestroy() {
    EVENT_BUS.$off('EVENT_GET_REPORT_LIST', this.loadData);
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('reports', [
      'getReportType',
      'getReportTemplateList',
      'isEmptyReportTemplateList',
    ]),
  },
  methods: {
    async loadData(type) {
      this.loading = true;

      try {
        await this.fetchReportTemplateListByType(type);

        if (this.isEmptyReportTemplateList) {
          this.$router.push({
            name: 'report.main',
            query: { type },
          });
          return;
        }

        EVENT_BUS.$emit('EVENT_SHOW_REPORT_LIST');
      } catch (error) {
        console.error(error);
        EVENT_BUS.$emit('EVENT_HIDE_REPORT_LIST');
      } finally {
        this.loading = false;
      }
    },
    handleEdit(reportTemplate) {
      if (this.$validate.isUndefined(reportTemplate)) {
        this.$router.push({
          name: 'report.main',
          query: {
            type: this.getReportType,
          },
        });
        return;
      }

      this.$router.push({
        name: 'report.template',
        params: {
          templateId: reportTemplate.id,
        },
        query: {
          type: this.getReportType,
        },
      });
    },
    async handleDelete(templateId) {
      try {
        await this.deleteReportTemplateById(templateId);
      } catch (error) {
        console.error(error);
      }
    },
    ...mapActions('partnership', [
      'fetchPartnerList',
    ]),
    ...mapActions('reports', [
      'fetchReportTemplateListByType',
      'deleteReportTemplateById',
    ]),
  },
};
</script>
